import { CopyIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { UnsplashImageSearch } from '../common/UnsplashImageSearch';

export const NewsCopyModal = observer(
    ({
        onCopyTitle,
        onCopyContent,
    }: {
        onCopyTitle: () => Promise<void>;
        onCopyContent: () => Promise<void>;
    }) => {
        return (
            <div className="flex flex-col gap-4">
                {/* 복사 버튼 영역 */}
                <div className="flex flex-col gap-2">
                    <a
                        href="https://blog.naver.com/haewao?Redirect=Write"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link link-hover"
                    >
                        블로그
                    </a>
                    <button
                        className="btn btn-outline btn-block justify-start"
                        onClick={onCopyTitle}
                    >
                        <CopyIcon className="size-4" />
                        제목 복사
                    </button>
                    <button
                        className="btn btn-outline btn-block justify-start"
                        onClick={onCopyContent}
                    >
                        <CopyIcon className="size-4" />
                        본문 복사
                    </button>
                </div>

                {/* 구분선 */}
                <div className="divider my-0">이미지 검색</div>

                {/* 이미지 검색 영역 */}
                <UnsplashImageSearch />
            </div>
        );
    },
);
